import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner,Form, Modal, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../Preloader";
import '../../styles/common.css';
import {  getIndustries, getSectors, profileDetails, updateSupplier } from "../../redux/actions/SupplierActions";
import Select from "react-dropdown-select";

const UpdateProfile = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [keyPoints, setKeyPoints] = useState([]);
  const [keyPointInput, setKeyPointInput] = useState("");
  const [supplierType, setSupplierType] = useState([
    { id: "Service", name: "Service" },
    { id: "Manufacturing", name: "Manufacturing" }
]);
  const dispatch = useDispatch();

  const {
    AuthReducer: { auth, errors },
    supplierReducer: { supplierDetails, errorsSupplier, loadingSupplier,changedSupplierStatus,sectors,industries,message }
  } = useSelector((state) => state);

  useEffect(() => {
    setFormData({});
    dispatch(profileDetails(auth?.token));
    dispatch(getSectors());
  }, [auth]);

  useEffect(() => {
    if (editId && supplierDetails) {
      const initialKeyPoints = JSON.parse(supplierDetails?.key_points || "[]"); 
      setKeyPoints(Array.isArray(initialKeyPoints) ? initialKeyPoints : []);
      setFormData({
        name: supplierDetails.name,
        designation: supplierDetails.designation,
        additional_info: supplierDetails.additional_info,
        address: supplierDetails.address,
        brochure: supplierDetails.brochure,
        business_name: supplierDetails.business_name,
        city: supplierDetails.city,
        email: supplierDetails.email,
        enterprise_logo: supplierDetails.enterprise_logo,
        gst_number: supplierDetails.gst_number,
        key_points: Array.isArray(initialKeyPoints) ? initialKeyPoints : [],
        mobile: supplierDetails.mobile,
        photo_graph: supplierDetails.photo_graph,
        pincode: supplierDetails.pincode,
        profile_image: supplierDetails.profile_image,
        remark: supplierDetails.remark,
        sectors: [supplierDetails.sectors[0]?.sector?.id],
        industries: supplierDetails.industries.map(item => item?.industry?.id),
        signature: supplierDetails.signature,
        state: supplierDetails.state,
        total_experience: supplierDetails.total_experience,
        type: supplierDetails.type,
        website_url: supplierDetails.website_url,
        bank_name: supplierDetails.bank_name,
        bank_ifsc_code: supplierDetails.bank_ifsc_code,
        bank_branch_name: supplierDetails.bank_branch_name,
        bank_account_number: supplierDetails.bank_account_number,
        bank_person_name: supplierDetails.bank_person_name,
    });
    }
  }, [supplierDetails, editId]);

  useEffect(() => {
    if(formData.sectors){
      dispatch(getIndustries(formData.sectors));
    }
  }, [formData.sectors]);

  const inputHandler = (e) => {
    const { value, name, files } = e.target;
    if (files && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
  
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }
    const formDataToSend = new FormData();
    for (let key in formData) {
      if (formData[key]) {
        if (Array.isArray(formData[key])) {
          formData[key].forEach((item) => {
            formDataToSend.append(`${key}[]`, item); 
          });
        } else {
          formDataToSend.append(key, formData[key]);
        }
      }
    }
  
    dispatch(updateSupplier(auth?.token, formDataToSend));
  };


  useEffect(() => {
    if (errors && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide();
    }
  }, [errors, dispatch, onHide]);

  const handleAddKeyPoint = () => {
    if (keyPointInput.trim() !== "") {
      setKeyPoints((prev) => {
        const updatedKeyPoints = [...prev, keyPointInput];
        setFormData((prevFormData) => ({
          ...prevFormData,
          key_points: updatedKeyPoints,
        }));
    
        return updatedKeyPoints;
      });
      setKeyPointInput("");
    }
  };
  const handleDeleteKeyPoint = (index) => {
    setKeyPoints((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(()=>{
  },[formData]);
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {t("Update Supplier")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorsSupplier?.data?.message && (
          <div className="alert alert-danger">
            {errorsSupplier?.data?.message}
          </div>
        )}
        <Row>
          <Col lg={6}>
            <FormInput
              label={t("Name")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.name}
              name="name"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Email")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.email}
              name="email"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Mobile")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.mobile}
              name="mobile"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Designation")}
              type="text"
              errors={errorsSupplier?.designation}
              value={formData.designation}
              name="designation"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Total Experience")}
              type="number"
              min="0"
              errors={errorsSupplier?.data}
              value={formData?.total_experience}
              name="total_experience"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Bussiness Name")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.business_name}
              name="business_name"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Sector")}</Form.Label>
                <Select
                    options={sectors}
                    values={sectors.filter(option => option.id == formData?.sectors) || []} // Fixed comparison
                    name="sectors"
                    labelField="name"
                    valueField="id"
                    searchBy="name"
                    onChange={(selectedData) => {
                        if (selectedData.length > 0) {
                            setFormData(prev => ({
                                ...prev,
                                sectors: [selectedData[0]?.id]
                            }));
                        }
                    }}
                    styles={null}
                />
                {errorsSupplier?.data?.sectors && (
                  <div className="invalid-feedback d-block">
                      <p className="text-danger">{errorsSupplier?.data?.sectors}</p>
                  </div>
                )}
            </Form.Group>
          </Col>
          <Col lg={6}>
             <Form.Group className="mb-3">
              <Form.Label>{t("Industries")}</Form.Label>
                <Select
                  options={industries}
                  values={industries.filter(option => formData?.industries?.includes(option.id)) || []} 
                  name="industries"
                  labelField="name"
                  valueField="id"
                  searchBy="name"
                  multi={true}
                  onChange={(selectedData) => {
                      setFormData(prev => ({
                          ...prev,
                          industries: selectedData.map(item => item.id)
                      }));
                  }}
                  styles={null}
                />
                {errorsSupplier?.data?.industries && (
                  <div className="invalid-feedback d-block">
                      <p className="text-danger">{errorsSupplier?.data?.industries}</p>
                  </div>
                )}
            </Form.Group>
          </Col>
          <Col lg={6}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Supplier Type")}</Form.Label>
                <Select
                options={supplierType}
                values={supplierType.filter((option) => option.id == formData?.type)}
                name="type"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                onChange={(selectedData) => {
                  setFormData(prev => ({
                      ...prev,
                      type: selectedData[0]?.id
                  }));
                }}
                styles={null}
                />
                {errorsSupplier?.data?.type && (
                  <div className="invalid-feedback d-block">
                      <p className="text-danger">{errorsSupplier?.data?.type}</p>
                  </div>
                )}
            </Form.Group>
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Pincode")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.pincode}
              name="pincode"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("City")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.city}
              name="city"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("State")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.state}
              name="state"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Address")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.address}
              name="address"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("GST Number")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.gst_number}
              name="gst_number"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Profile Image")}
              type="file"
              errors={errorsSupplier?.data}
              name="profile_image"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Brochure")}
              type="file"
              errors={errorsSupplier?.data}
              name="brochure"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Enterprise Logo")}
              type="file"
              errors={errorsSupplier?.data}
              name="enterprise_logo"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={12}>
            <FormInput
              label={t("Remark")}
              type="textarea"
              errors={errorsSupplier?.data}
              value={formData?.remark}
              name="remark"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={12}>
            <div className="d-flex align-items-center gap-2">
              <FormInput
                label={t("Add Key Points")}
                type="text"
                errors={errorsSupplier?.data}
                value={keyPointInput}
                name="name"
                onChange={(e) => setKeyPointInput(e.target.value)}
                containerClass="mb-0"
                required
              />
              <Button type="button" className="mt-3" onClick={handleAddKeyPoint} disabled={!keyPointInput.trim()}>
                {t("Add")}
              </Button>
            </div>
          </Col>
          {keyPoints.length > 0 && (
            <Col lg={12} className="mt-3">
              <Table bordered>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Key Points</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {keyPoints.map((keyPoint, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{keyPoint}</td>
                      <td>
                        <Button variant="danger" size="sm" onClick={() => handleDeleteKeyPoint(index)}>
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          )}
          <Col lg={6}>
            <FormInput
              label={t("Signature")}
              type="file"
              errors={errorsSupplier?.data}
              name="signature"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Website URL")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.website_url}
              name="website_url"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={12}>
            <FormInput
              label={t("Additional Information")}
              type="textarea"
              errors={errorsSupplier?.data}
              value={formData?.additional_info}
              name="additional_info"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Bank Name")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.bank_name}
              name="bank_name"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Bank Ifsc Code")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.bank_ifsc_code}
              name="bank_ifsc_code"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Bank Branch Name")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.bank_branch_name}
              name="bank_branch_name"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Bank Account Number")}
              type="number"
              min="0"
              errors={errorsSupplier?.data}
              value={formData?.bank_account_number}
              name="bank_account_number"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
          <Col lg={6}>
            <FormInput
              label={t("Bank Person Name")}
              type="text"
              errors={errorsSupplier?.data}
              value={formData?.bank_person_name}
              name="bank_person_name"
              onChange={inputHandler}
              containerClass="mb-3"
              required
            />
          </Col>
         
         
        </Row>
        <div className="d-flex justify-content-center">
          {loadingSupplier ? (
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          ) : (
            <Button type="button" onClick={handleSubmit} disabled={loadingSupplier}>
              {t("Update")}
            </Button>
          )}
        </div>
      </Modal.Body>
      {loadingSupplier && <Preloader />}
    </Modal>
  );
};

export default UpdateProfile;
